module.exports = __webpack_public_path__ + "static/presidents-message-bb22306440406c15031b06ff21069b55.jpg";